module.exports = __webpack_public_path__ + "img/product13.a2685d28.jpg";